import { ReactNode } from "react";
import { OfferTokenValues } from "types/api/exclusive_offers.d";
import { renderPlaceholderValue } from "./PlaceholderValueFormatter";

export const offerPlaceholderResolver = (
  tokenValues: OfferTokenValues = {}
) => {
  return (placeholders: string[]): ReactNode => {
    return placeholders.map((placeholder) => {
      const value = tokenValues[placeholder];
      return renderPlaceholderValue(placeholder, value);
    });
  };
};
